<template>
  <div class="deposit-modal-wrapper">
    <button id="modal-drop-btn" type="button" style="display: none" data-bs-toggle="modal"
            data-bs-target="#staticDepositBackdrop"></button>

    <div class="modal fade" id="staticDepositBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="staticDepositBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="staticDepositBackdropLabel">Deposit to Cash Safe</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeDepositModal"
                    aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="makePayment">
              <div class="row mb-3">
                <div class="col-md-6">
                  <div class="form-floating select-container">
                    <select 
                      class="form-select custom-select"
                      id="cashAccounts"
                      v-model="form.chartID"
                      :required="!form.chartID"
                    >
                      <option value="" disabled selected>Select safe</option>
                      <option v-for="(safe, n) in safes" :key="n" :value="safe.id">{{ safe.ChartName }}</option>
                    </select>
                    <label for="cashAccounts">Safe</label>
                    <div class="select-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="depositAmount">Deposit Amount</label>
                  <input id="depositAmount" type="number" step="0.01" v-model.number="form.amount" class="form-control">
                </div>
              </div>

              <div class="row m-1">
                <label for="paymentDescription">Deposit Reason / Description</label>
                <textarea class="form-control" placeholder="Deposit Reason / Description" rows="3"
                          required id="paymentDescription" v-model="form.reason"/>
              </div>

              <div class="row mt-2 d-flex justify-content-center">
                <button class="btn btn-primary w-50 h-100" type="submit">Process</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CashDrop',
  beforeMount() {
    this.resetDeposit();
  },
  data() {
    return {
      isAllowed: false,
      safes: [],
      form: {
        chartID: null,
        reason: null,
        amount: null
      }
    }
  },
  methods: {
    makePayment() {
      this.$utils.showLoading();
      return this.$store.dispatch(`captureCashDrop`, this.form)
          .then(() => {
            responses.showSuccess(`Deposit Successful`)
            document.getElementById("closeDepositModal").click();
            this.resetDeposit();
          }).finally(() => this.$utils.hideLoading())
    },

    resetDeposit() {
      this.safes = [];
      this.form = {
        chartID: null,
        reason: null,
        amount: null
      }
    },


    searchSafes() {
      this.$utils.showLoading()
      return this.$store.dispatch(`getCashSafes`)
          .then(res => this.safes = res)
          .finally(() => this.$utils.hideLoading())
    },
    async cashDrop() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, 'DropCash');
      if (!isAllowed) return;
      return this.searchSafes().then(() => {
        this.$utils.hideLoading()
        document.getElementById(`modal-drop-btn`).click();
      })
    },
    // Public method to open modal from parent (FAB)
    open() {
      return this.cashDrop();
    }
  }
}
</script>
<style lang="scss">
.payout-btn {
  padding: 0;
  border: #f1f1f1 solid 1px;
  border-radius: 5px;
  margin: 0.5em;

  .list-item, a {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 600;
    font-size: 20px;
    padding: 10px;
    text-decoration: none;
    color: #1c1c1c;

    .icon-box {
      width: 35px;
      margin-right: 10px;
      display: flex;
      justify-content: center;

      .icon {
        font-size: 25px;
        color: #34373C;
      }
    }

    &:hover, &.router-link-exact-active {
      background: #f1f1f1;
      color: #1e88e5;
      font-weight: 700;

      .icon-box {
        .icon {
          color: #1e88e5;
        }
      }
    }
  }
}

.select-container {
  position: relative;
}

.select-arrow {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--accent-electric-blue);
  transition: transform 0.3s ease;

  svg {
    transition: transform 0.3s ease;
  }
}

.custom-select {
  border: var(--card-border);
  background-color: var(--card-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  height: 56px;
  font-size: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;

  &:focus {
    box-shadow: 0 0 0 3px rgba(var(--accent-electric-blue-rgb), 0.25);
    border-color: var(--accent-electric-blue);
    outline: none;

    & + label + .select-arrow svg {
      transform: rotate(180deg);
    }
  }

  &:hover:not(:focus) {
    border-color: var(--accent-electric-blue);

    & + label + .select-arrow {
      color: var(--accent-neon-purple);
    }
  }

  option {
    padding: 10px;
    font-size: 1rem;
  }
}

.form-floating label {
  padding: 0.75rem 1rem;
  color: var(--text-secondary);
  font-weight: 500;
  pointer-events: none;
}
</style>